import { useQuery } from 'react-query';
import { axiosInstance } from '../utils/axios';

export const usePermission = (corpAcctNbr) => {
  const authv3Permissions = [
    {
      action: {
        name: 'READ',
      },
      resource: {
        name: 'CONVERSION_CDA_JOB',
        org: {
          id: 1,
        },
        scope: {
          name: 'ACCOUNT_MIGRATION',
        },
        type: 'ENTITY',
      },
      resourceOrg: {
        externalId: corpAcctNbr,
        type: 'CORP_ACCOUNT',
      },
    },
    {
      action: {
        name: 'READ',
      },
      resource: {
        name: 'PRODUCT_LIMIT',
        org: {
          id: 1,
        },
        scope: {
          name: 'LICENSING',
        },
        type: 'ENTITY',
      },
      resourceOrg: {
        externalId: corpAcctNbr,
        type: 'CORP_ACCOUNT',
      },
    },
  ];

  return useQuery('permissions', () =>
    axiosInstance.post('/authorization/v1/policyDecisionRequests', authv3Permissions),
  );
};
